import { render, staticRenderFns } from "./EinstellungenThemeComp.vue?vue&type=template&id=2a741a34&scoped=true&"
import script from "./EinstellungenThemeComp.vue?vue&type=script&lang=ts&"
export * from "./EinstellungenThemeComp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a741a34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
